import { Field } from 'scripts/type'

export default function getDefaultShowFields(fields: Field[]) {
  const targetCodes = fields.reduce((acc, field) => {
    const targets = (field.showRules || []).reduce((ruleAcc, rule) => {
      return ruleAcc.concat(rule.targets || [])
    }, [] as string[])
    return acc.concat(targets)
  }, [] as string[])
  return fields.filter((field) => !targetCodes.includes(field.code)).map((field) => [field])
}
